import { render, staticRenderFns } from "./IconPin.vue?vue&type=template&id=d8920f36&scoped=true&"
import script from "./IconPin.vue?vue&type=script&lang=js&"
export * from "./IconPin.vue?vue&type=script&lang=js&"
import style0 from "./IconPin.vue?vue&type=style&index=0&id=d8920f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8920f36",
  null
  
)

export default component.exports